import { Controller } from '@hotwired/stimulus'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import AgentWorkRegistration from '@/components/agent_work_regstration.vue'
import SelectButton from 'primevue/selectbutton'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'

axios.defaults.headers.common['X-CSRF-Token'] = document
  .querySelector('meta[name="csrf-token"]')
  .getAttribute('content')
export default class extends Controller {
  static targets = ['calendar']
  connect() {
    const app = createApp(AgentWorkRegistration, {
      agentId: this.element.dataset.agentId,
      creators: JSON.parse(this.element.dataset.creators),
      currentUser: JSON.parse(this.element.dataset.currentUser),
      wholeWorkPeriod: JSON.parse(this.element.dataset.wholeWorkPeriod),
      shiftOptions: JSON.parse(this.element.dataset.shiftOptions)
    })
    app.use(PrimeVue)
    app.component('SelectButton', SelectButton)
    app.component('VueElementLoading', VueElementLoading)
    app.mount(this.calendarTarget)
  }
}
